import React from "react";

/* ── Dedicated Hub Icons (self-contained) ── */
function ReceiptIcon() {
  return (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6" width="14" height="14">
      <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
      <polyline points="14 2 14 8 20 8" />
      <line x1="16" y1="13" x2="8" y2="13" />
      <line x1="16" y1="17" x2="8" y2="17" />
      <line x1="10" y1="9" x2="8" y2="9" />
    </svg>
  );
}

function BoxIcon() {
  return (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6" width="14" height="14">
      <path d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z" />
    </svg>
  );
}

/* ── 2 Hub Navigation Items ── */
const TABS = [
  { id: "Stock Receipt", label: "Vendor Inward (Stock Receipts)", icon: <ReceiptIcon /> },
  { id: "Stocks",        label: "Stock",                         icon: <BoxIcon /> },
];

export default function InventoryHubNav({ active }) {
  const navTo = (target) => {
    window.dispatchEvent(new CustomEvent("reva:navigate", { detail: target }));
  };

  return (
    <div className="rv-hub-nav">
      {TABS.map((tab) => {
        const isActive = active === tab.id;
        return (
          <button
            key={tab.id}
            type="button"
            className={`rv-hub-tab ${isActive ? "rv-hub-tab--active" : ""}`}
            onClick={() => navTo(tab.id)}
          >
            {tab.icon} {tab.label}
          </button>
        );
      })}
    </div>
  );
}
